import { render } from "./Button.vue?vue&type=template&id=467ccd5e&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=467ccd5e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-467ccd5e"

export default script